import styled from "styled-components";
export const PlusIcn = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px 12px;
  padding:12px;
  border-radius: 8px;
  background-color: rgba(53, 58, 80, 0.1);
  width: 100%;
  color: #353a50;
  font-weight: 900;
  /* white-space: nowrap; */
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
export const Answers = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  font-weight: normal;
`;
